import SmartLoader from './SmartLoader';
export default SmartLoader;
